<template>
  <div class="system-settings">
    <div class="header">
      <h2>系统设置</h2>
      <el-button type="primary" @click="initDefaultSettings">
        <el-icon><Refresh /></el-icon>
        初始化默认设置
      </el-button>
    </div>

    <el-card>
      <el-tabs v-model="activeTab">
        <!-- 微信设置 -->
        <el-tab-pane label="微信设置" name="wechat">
          <div v-loading="loading.wechat">
            <!-- 小程序配置 -->
            <el-divider content-position="left">
              <el-icon><Iphone /></el-icon> 微信小程序配置
            </el-divider>
            <el-form :model="wechatConfig.miniProgram" label-width="140px">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="启用小程序">
                    <el-switch v-model="wechatConfig.miniProgram.enabled" />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="小程序原始ID">
                    <el-input v-model="wechatConfig.miniProgram.originalId" placeholder="gh_xxxxxxxx" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="AppId">
                    <el-input v-model="wechatConfig.miniProgram.appId" placeholder="小程序AppId" />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="AppSecret">
                    <el-input v-model="wechatConfig.miniProgram.appSecret" placeholder="小程序AppSecret" show-password />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="小程序码URL">
                    <el-input v-model="wechatConfig.miniProgram.qrCodeUrl" placeholder="小程序码图片地址" />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>

            <!-- 公众平台服务号配置 -->
            <el-divider content-position="left">
              <el-icon><ChatDotRound /></el-icon> 公众平台服务号配置
            </el-divider>
            <el-alert type="info" :closable="false" style="margin-bottom: 16px;">
              <template #title>
                <strong>服务号功能：</strong>自定义菜单、模板消息、网页授权登录、微信支付、小程序关联等
              </template>
            </el-alert>
            <el-form :model="wechatConfig.officialAccount" label-width="140px">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="启用服务号">
                    <el-switch v-model="wechatConfig.officialAccount.enabled" />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="服务号原始ID">
                    <el-input v-model="wechatConfig.officialAccount.originalId" placeholder="gh_xxxxxxxx" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="AppId">
                    <el-input v-model="wechatConfig.officialAccount.appId" placeholder="服务号AppId" />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="AppSecret">
                    <el-input v-model="wechatConfig.officialAccount.appSecret" placeholder="服务号AppSecret" show-password />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="Token">
                    <el-input v-model="wechatConfig.officialAccount.token" placeholder="服务器配置Token" />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="EncodingAESKey">
                    <el-input v-model="wechatConfig.officialAccount.encodingAESKey" placeholder="消息加解密密钥(43位)" />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>

            <!-- 微信支付配置 -->
            <el-divider content-position="left">
              <el-icon><Wallet /></el-icon> 微信支付配置（商户平台）
            </el-divider>
            <el-alert type="warning" :closable="false" style="margin-bottom: 16px;">
              <template #title>
                <strong>申请步骤：</strong>1.注册商户平台 → 2.提交资质审核 → 3.签署协议 → 4.绑定AppId → 5.配置API密钥和证书
              </template>
            </el-alert>
            <el-form :model="wechatConfig.pay" label-width="160px">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="启用微信支付">
                    <el-switch v-model="wechatConfig.pay.enabled" />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="商户号">
                    <el-input v-model="wechatConfig.pay.mchId" placeholder="微信商户号" />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="商户证书序列号">
                    <el-input v-model="wechatConfig.pay.serialNo" placeholder="证书序列号" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="API密钥(V2)">
                    <el-input v-model="wechatConfig.pay.apiKey" placeholder="32位API密钥" show-password />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="APIv3密钥(V3)">
                    <el-input v-model="wechatConfig.pay.apiV3Key" placeholder="32位APIv3密钥" show-password />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="商户私钥">
                    <el-input v-model="wechatConfig.pay.privateKey" type="textarea" :rows="4" placeholder="商户私钥内容或路径" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="支付回调地址">
                    <el-input v-model="wechatConfig.pay.notifyUrl" placeholder="https://xxx/api/payment/notify" />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="退款回调地址">
                    <el-input v-model="wechatConfig.pay.refundNotifyUrl" placeholder="https://xxx/api/payment/refund-notify" />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>

            <div style="margin-top: 20px; text-align: right;">
              <el-button type="primary" @click="saveWechatConfig" :loading="saving.wechat">
                <el-icon><Check /></el-icon> 保存微信配置
              </el-button>
            </div>
          </div>
        </el-tab-pane>

        <!-- 抽成规则设置 -->
        <el-tab-pane label="抽成规则" name="commission">
          <div v-loading="loading.commission">
            <el-divider content-position="left">
              <el-icon><Money /></el-icon> 消费返佣基础设置
            </el-divider>
            <el-form :model="commissionConfig" label-width="160px">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="平台利润比例">
                    <el-input-number v-model="commissionConfig.platformProfitRate" :min="0" :max="1" :step="0.05" :precision="2" />
                    <span class="unit">({{ (commissionConfig.platformProfitRate * 100).toFixed(0) }}%)</span>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="用户分成比例">
                    <el-input-number v-model="commissionConfig.userShareRate" :min="0" :max="1" :step="0.05" :precision="2" />
                    <span class="unit">({{ (commissionConfig.userShareRate * 100).toFixed(0) }}%)</span>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <!-- V4.0 债权人消费配置 -->
            <el-divider content-position="left">
              <el-icon><User /></el-icon> 债权人消费返佣（V4.0）
            </el-divider>
            <el-form :model="commissionConfig.creditorConsumption" label-width="160px">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="解债分比例">
                    <el-input-number v-model="commissionConfig.creditorConsumption.debtResolutionRate" :min="0" :max="1" :step="0.01" :precision="3" />
                    <span class="unit">({{ (commissionConfig.creditorConsumption.debtResolutionRate * 100).toFixed(1) }}%)</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="平台利润比例">
                    <el-input-number v-model="commissionConfig.creditorConsumption.platformRate" :min="0" :max="1" :step="0.01" :precision="3" />
                    <span class="unit">({{ (commissionConfig.creditorConsumption.platformRate * 100).toFixed(1) }}%)</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-alert type="info" :closable="false">
                债权人消费返佣：解债分{{ (commissionConfig.creditorConsumption.debtResolutionRate * 100).toFixed(1) }}% + 平台{{ (commissionConfig.creditorConsumption.platformRate * 100).toFixed(1) }}% = 100%
              </el-alert>
            </el-form>
            <!-- V4.0 亲友团消费配置 -->
            <el-divider content-position="left">
              <el-icon><Avatar /></el-icon> 亲友团消费返佣（V4.0）
            </el-divider>
            <el-form :model="commissionConfig.friendConsumption" label-width="160px">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="解债分比例">
                    <el-input-number v-model="commissionConfig.friendConsumption.debtResolutionRate" :min="0" :max="1" :step="0.01" :precision="3" />
                    <span class="unit">({{ (commissionConfig.friendConsumption.debtResolutionRate * 100).toFixed(1) }}%)</span>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="帮扶分比例">
                    <el-input-number v-model="commissionConfig.friendConsumption.helperCreditRate" :min="0" :max="1" :step="0.01" :precision="3" />
                    <span class="unit">({{ (commissionConfig.friendConsumption.helperCreditRate * 100).toFixed(1) }}%)</span>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="平台利润比例">
                    <el-input-number v-model="commissionConfig.friendConsumption.platformRate" :min="0" :max="1" :step="0.01" :precision="3" />
                    <span class="unit">({{ (commissionConfig.friendConsumption.platformRate * 100).toFixed(1) }}%)</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-alert type="info" :closable="false">
                亲友团消费返佣：解债分{{ (commissionConfig.friendConsumption.debtResolutionRate * 100).toFixed(1) }}% + 帮扶分{{ (commissionConfig.friendConsumption.helperCreditRate * 100).toFixed(1) }}% + 平台{{ (commissionConfig.friendConsumption.platformRate * 100).toFixed(1) }}% = 100%
              </el-alert>
            </el-form>

            <el-divider content-position="left">
              <el-icon><Shop /></el-icon> 行业抽成设置
            </el-divider>
            <el-table :data="industryTableData" border stripe style="margin-bottom: 20px;">
              <el-table-column prop="name" label="行业类型" width="150" />
              <el-table-column prop="subName" label="子分类" width="120" />
              <el-table-column label="抽成比例" width="200">
                <template #default="{ row }">
                  <el-input-number v-model="row.rate" :min="0" :max="0.2" :step="0.005" :precision="4" size="small" />
                </template>
              </el-table-column>
              <el-table-column label="百分比">
                <template #default="{ row }">
                  <el-tag :type="row.rate >= 0.08 ? 'danger' : row.rate >= 0.05 ? 'warning' : 'success'">
                    {{ (row.rate * 100).toFixed(2) }}%
                  </el-tag>
                </template>
              </el-table-column>
            </el-table>

            <el-divider content-position="left">
              <el-icon><List /></el-icon> 任务分配规则
            </el-divider>
            <el-table :data="taskTableData" border stripe style="margin-bottom: 20px;">
              <el-table-column prop="name" label="任务类型" width="150" />
              <el-table-column label="现金分" width="180">
                <template #default="{ row }">
                  <el-input-number v-model="row.cashRate" :min="0" :max="1" :step="0.05" :precision="2" size="small" />
                </template>
              </el-table-column>
              <el-table-column label="解债分" width="180">
                <template #default="{ row }">
                  <el-input-number v-model="row.debtRate" :min="0" :max="1" :step="0.05" :precision="2" size="small" />
                </template>
              </el-table-column>
              <el-table-column label="平台服务费" width="180">
                <template #default="{ row }">
                  <el-input-number v-model="row.platformRate" :min="0" :max="1" :step="0.05" :precision="2" size="small" />
                </template>
              </el-table-column>
              <el-table-column label="合计校验">
                <template #default="{ row }">
                  <el-tag :type="Math.abs(row.cashRate + row.debtRate + row.platformRate - 1) < 0.01 ? 'success' : 'danger'">
                    {{ ((row.cashRate + row.debtRate + row.platformRate) * 100).toFixed(0) }}%
                  </el-tag>
                </template>
              </el-table-column>
            </el-table>

            <el-divider content-position="left">
              <el-icon><CreditCard /></el-icon> 现金分卡手续费
            </el-divider>
            <el-form :model="commissionConfig.cashCard" label-width="160px" inline>
              <el-form-item label="线上购买手续费">
                <el-input-number v-model="commissionConfig.cashCard.onlineFeeRate" :min="0" :max="0.1" :step="0.01" :precision="4" />
                <span class="unit">({{ (commissionConfig.cashCard.onlineFeeRate * 100).toFixed(0) }}%)</span>
              </el-form-item>
              <el-form-item label="线下购买手续费">
                <el-input-number v-model="commissionConfig.cashCard.offlineFeeRate" :min="0" :max="0.1" :step="0.01" :precision="4" />
                <span class="unit">({{ (commissionConfig.cashCard.offlineFeeRate * 100).toFixed(0) }}%)</span>
              </el-form-item>
            </el-form>
            <!-- V4.0 积分手续费设置 -->
            <el-divider content-position="left">
              <el-icon><Wallet /></el-icon> 积分手续费设置（V4.0）
            </el-divider>
            <el-form :model="commissionConfig.creditFees" label-width="160px">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="提现手续费">
                    <el-input-number v-model="commissionConfig.creditFees.withdrawFeeRate" :min="0" :max="0.5" :step="0.01" :precision="2" />
                    <span class="unit">({{ (commissionConfig.creditFees.withdrawFeeRate * 100).toFixed(0) }}%)</span>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="交易手续费">
                    <el-input-number v-model="commissionConfig.creditFees.tradeFeeRate" :min="0" :max="0.5" :step="0.01" :precision="2" />
                    <span class="unit">({{ (commissionConfig.creditFees.tradeFeeRate * 100).toFixed(0) }}%)</span>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="转账手续费">
                    <el-input-number v-model="commissionConfig.creditFees.transferFeeRate" :min="0" :max="0.5" :step="0.01" :precision="2" />
                    <span class="unit">({{ (commissionConfig.creditFees.transferFeeRate * 100).toFixed(0) }}%)</span>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <!-- V4.0 积分功能开关 -->
            <el-divider content-position="left">
              <el-icon><Setting /></el-icon> 积分功能开关（V4.0）
            </el-divider>
            <el-form :model="commissionConfig.creditSwitches" label-width="160px">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="交易功能">
                    <el-switch v-model="commissionConfig.creditSwitches.tradeEnabled" active-text="开启" inactive-text="关闭" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="转账功能">
                    <el-switch v-model="commissionConfig.creditSwitches.transferEnabled" active-text="开启" inactive-text="关闭" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="帮扶分兑换">
                    <el-switch v-model="commissionConfig.creditSwitches.helperExchangeEnabled" active-text="开启" inactive-text="关闭" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="提现功能">
                    <el-switch v-model="commissionConfig.creditSwitches.withdrawEnabled" active-text="开启" inactive-text="关闭" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="最低提现金额">
                    <el-input-number v-model="commissionConfig.creditSwitches.minWithdrawAmount" :min="100" :max="10000" :step="100" />
                    <span class="unit">元</span>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>

            <div style="margin-top: 20px; text-align: right;">
              <el-button type="primary" @click="saveCommissionConfig" :loading="saving.commission">
                <el-icon><Check /></el-icon> 保存抽成规则
              </el-button>
            </div>
          </div>
        </el-tab-pane>

        <!-- 地图设置 -->
        <el-tab-pane label="地图设置" name="map">
          <div v-loading="loading.map">
            <el-form :model="mapConfig" label-width="140px">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="启用地图服务">
                    <el-switch v-model="mapConfig.enabled" />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="地图服务商">
                    <el-select v-model="mapConfig.provider">
                      <el-option label="腾讯地图" value="tencent" />
                      <el-option label="百度地图" value="baidu" />
                      <el-option label="高德地图" value="amap" />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="腾讯地图Key">
                    <el-input v-model="mapConfig.tencentKey" placeholder="腾讯地图开发者Key" />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="百度地图AK">
                    <el-input v-model="mapConfig.baiduAk" placeholder="百度地图开发者AK" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="高德地图Key">
                    <el-input v-model="mapConfig.amapKey" placeholder="高德地图开发者Key" />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="高德安全密钥">
                    <el-input v-model="mapConfig.amapSecret" placeholder="高德地图安全密钥" />
                  </el-form-item>
                </el-col>
              </el-row>
              <div style="text-align: right; margin-top: 20px;">
                <el-button type="primary" @click="saveMapConfig" :loading="saving.map">
                  <el-icon><Check /></el-icon> 保存地图配置
                </el-button>
              </div>
            </el-form>
          </div>
        </el-tab-pane>

        <!-- 短信设置 -->
        <el-tab-pane label="短信设置" name="sms">
          <div v-loading="loading.sms">
            <el-form :model="smsConfig" label-width="140px">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="启用短信服务">
                    <el-switch v-model="smsConfig.enabled" />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="短信服务商">
                    <el-select v-model="smsConfig.provider">
                      <el-option label="腾讯云" value="tencent" />
                      <el-option label="阿里云" value="aliyun" />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-divider content-position="left">腾讯云短信配置</el-divider>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="SecretId">
                    <el-input v-model="smsConfig.tencentSecretId" placeholder="腾讯云SecretId" />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="SecretKey">
                    <el-input v-model="smsConfig.tencentSecretKey" placeholder="腾讯云SecretKey" show-password />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="短信AppId">
                    <el-input v-model="smsConfig.tencentAppId" placeholder="短信应用AppId" />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="短信签名">
                    <el-input v-model="smsConfig.tencentSignName" placeholder="短信签名" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="验证码模板ID">
                    <el-input v-model="smsConfig.tencentTemplateId" placeholder="验证码模板ID" />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="邀请模板ID">
                    <el-input v-model="smsConfig.tencentInviteTemplateId" placeholder="邀请短信模板ID" />
                  </el-form-item>
                </el-col>
              </el-row>
              <div style="text-align: right; margin-top: 20px;">
                <el-button type="primary" @click="saveSmsConfig" :loading="saving.sms">
                  <el-icon><Check /></el-icon> 保存短信配置
                </el-button>
              </div>
            </el-form>
          </div>
        </el-tab-pane>

        <!-- 电子签设置 -->
        <el-tab-pane label="电子签设置" name="esign">
          <div v-loading="loading.esign">
            <el-form :model="esignConfig" label-width="140px">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="启用电子签">
                    <el-switch v-model="esignConfig.enabled" />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="电子签服务商">
                    <el-select v-model="esignConfig.provider">
                      <el-option label="富福德正网签系统" value="self" />
                      <el-option label="腾讯电子签" value="tencent" />
                      <el-option label="法大大" value="fadada" />
                      <el-option label="e签宝" value="esign" />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <template v-if="esignConfig.provider === 'tencent'">
                <el-divider content-position="left">腾讯电子签配置</el-divider>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="SecretId">
                      <el-input v-model="esignConfig.tencentSecretId" placeholder="腾讯云SecretId" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="SecretKey">
                      <el-input v-model="esignConfig.tencentSecretKey" placeholder="腾讯云SecretKey" show-password />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="应用AppId">
                      <el-input v-model="esignConfig.tencentAppId" placeholder="电子签应用AppId" />
                    </el-form-item>
                  </el-col>
                </el-row>
              </template>
            </el-form>
            <div style="text-align: right; margin-top: 20px;">
              <el-button type="primary" @click="saveEsignConfig" :loading="saving.esign">
                <el-icon><Check /></el-icon> 保存电子签配置
              </el-button>
            </div>
          </div>
        </el-tab-pane>

        <!-- 邮件设置 -->
        <el-tab-pane label="邮件设置" name="email">
          <div v-loading="loading.email">
            <el-form :model="emailConfig" label-width="140px">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="启用邮件服务">
                    <el-switch v-model="emailConfig.enabled" />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="发件人名称">
                    <el-input v-model="emailConfig.fromName" placeholder="发件人名称" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="SMTP服务器">
                    <el-input v-model="emailConfig.host" placeholder="smtp.qq.com" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="端口">
                    <el-input-number v-model="emailConfig.port" :min="1" :max="65535" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="使用SSL">
                    <el-switch v-model="emailConfig.secure" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="邮箱账号">
                    <el-input v-model="emailConfig.user" placeholder="your@email.com" />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="邮箱密码/授权码">
                    <el-input v-model="emailConfig.password" placeholder="密码或授权码" show-password />
                  </el-form-item>
                </el-col>
              </el-row>
              <div style="text-align: right; margin-top: 20px;">
                <el-button type="primary" @click="saveEmailConfig" :loading="saving.email">
                  <el-icon><Check /></el-icon> 保存邮件配置
                </el-button>
              </div>
            </el-form>
          </div>
        </el-tab-pane>
        
        <!-- 协议管理 -->
        <el-tab-pane label="协议管理" name="agreement">
          <div v-loading="loading.agreement">
            <el-divider content-position="left">
              <el-icon><Document /></el-icon> 用户注册协议
            </el-divider>
            <el-form label-width="100px">
              <el-form-item label="协议内容">
                <el-input 
                  v-model="agreementConfig.userAgreement" 
                  type="textarea" 
                  :rows="10"
                  placeholder="请输入用户注册协议内容"
                />
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="saveAgreement('user')" :loading="saving.agreement">
                  <el-icon><Check /></el-icon> 保存用户协议
                </el-button>
              </el-form-item>
            </el-form>
            
            <el-divider content-position="left">
              <el-icon><Document /></el-icon> 隐私政策
            </el-divider>
            <el-form label-width="100px">
              <el-form-item label="政策内容">
                <el-input 
                  v-model="agreementConfig.privacyPolicy" 
                  type="textarea" 
                  :rows="10"
                  placeholder="请输入隐私政策内容"
                />
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="saveAgreement('privacy')" :loading="saving.agreement">
                  <el-icon><Check /></el-icon> 保存隐私政策
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
        <!-- 商户分类管理 -->
        <el-tab-pane label="商户分类" name="category">
          <div class="tab-content">
            <div class="section-header">
              <h3>商户分类管理</h3>
              <el-button type="primary" size="small" @click="handleAddCategory">
                <el-icon><Plus /></el-icon>
                添加分类
              </el-button>
            </div>
            
            <el-table :data="categoryList" v-loading="categoryLoading" stripe border>
              <el-table-column prop="id" label="ID" width="70" />
              <el-table-column prop="name" label="分类名称" min-width="150" />
              <el-table-column prop="description" label="描述" min-width="200">
                <template #default="{ row }">
                  {{ row.description || '-' }}
                </template>
              </el-table-column>
              <el-table-column prop="commissionRate" label="默认抽成" width="120">
                <template #default="{ row }">
                  {{ (row.commissionRate * 100).toFixed(1) }}%
                </template>
              </el-table-column>
              <el-table-column prop="isActive" label="状态" width="100">
                <template #default="{ row }">
                  <el-tag :type="row.isActive ? 'success' : 'danger'" size="small">
                    {{ row.isActive ? '启用' : '禁用' }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="createdAt" label="创建时间" width="160">
                <template #default="{ row }">
                  {{ formatDateTime(row.createdAt) }}
                </template>
              </el-table-column>
              <el-table-column label="操作" width="200" fixed="right">
                <template #default="{ row }">
                  <el-button type="primary" size="small" @click="handleEditCategory(row)">编辑</el-button>
                  <el-button 
                    :type="row.isActive ? 'warning' : 'success'" 
                    size="small" 
                    @click="handleToggleCategory(row)"
                  >
                    {{ row.isActive ? '禁用' : '启用' }}
                  </el-button>
                  <el-button type="danger" size="small" @click="handleDeleteCategory(row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
        <!-- 支付配置 V4.0 -->
        <el-tab-pane label="支付配置" name="payment">
          <div v-loading="loading.payment">
            <el-divider content-position="left">
              <el-icon><CreditCard /></el-icon> 提现支付配置
            </el-divider>
            <el-alert type="info" :closable="false" style="margin-bottom: 16px;">
              <template #title>
                <strong>配置说明：</strong>用于提现审核通过后的自动打款功能。选择「手动处理」时，审核通过后需管理员手动转账；选择其他渠道时需配置对应API参数。
              </template>
            </el-alert>
            <el-form :model="paymentConfig" label-width="140px">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="启用自动打款">
                    <el-switch v-model="paymentConfig.enabled" :disabled="paymentConfig.provider === 'manual'" />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="支付渠道">
                    <el-select v-model="paymentConfig.provider" style="width: 100%;" @change="onProviderChange">
                      <el-option label="手动处理" value="manual" />
                      <el-option label="微信支付" value="wechat" />
                      <el-option label="银行卡" value="bank" />
                      <el-option label="支付宝" value="alipay" />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <!-- 手动处理提示 -->
              <el-alert v-if="paymentConfig.provider === 'manual'" type="warning" :closable="false" style="margin-bottom: 16px;">
                <template #title>
                  <strong>手动处理模式：</strong>提现申请审核通过后，需管理员在「提现管理」中点击「发放」按钮，然后手动完成转账操作，再点击「确认已发放」。
                </template>
              </el-alert>

              <!-- 微信支付配置 -->
              <template v-if="paymentConfig.provider === 'wechat'">
                <el-divider content-position="left">微信支付配置</el-divider>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="商户号">
                      <el-input v-model="paymentConfig.merchantId" placeholder="微信商户号" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="签名方式">
                      <el-select v-model="paymentConfig.signType" style="width: 100%;">
                        <el-option label="MD5" value="MD5" />
                        <el-option label="HMAC-SHA256" value="HMAC-SHA256" />
                        <el-option label="RSA" value="RSA" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="API密钥(V2)">
                      <el-input v-model="paymentConfig.merchantKey" placeholder="32位API密钥" show-password />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="APIv3密钥">
                      <el-input v-model="paymentConfig.apiV3Key" placeholder="32位APIv3密钥" show-password />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="24">
                    <el-form-item label="商户证书">
                      <el-input v-model="paymentConfig.merchantCert" type="textarea" :rows="3" placeholder="商户私钥内容" />
                    </el-form-item>
                  </el-col>
                </el-row>
              </template>

              <!-- 银行卡配置 -->
              <template v-if="paymentConfig.provider === 'bank'">
                <el-divider content-position="left">银行账户信息（用于手动转账参考）</el-divider>
                <el-row :gutter="20">
                  <el-col :span="8">
                    <el-form-item label="开户银行">
                      <el-input v-model="paymentConfig.bankName" placeholder="如：招商银行" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="银行账号">
                      <el-input v-model="paymentConfig.bankAccount" placeholder="对公账号" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="账户名称">
                      <el-input v-model="paymentConfig.bankAccountName" placeholder="户名" />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-divider content-position="left">银行API配置（对接银企直连时填写）</el-divider>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="企业号">
                      <el-input v-model="paymentConfig.merchantId" placeholder="银行企业号" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="API密钥">
                      <el-input v-model="paymentConfig.merchantKey" placeholder="银行API密钥" show-password />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="24">
                    <el-form-item label="API地址">
                      <el-input v-model="paymentConfig.apiUrl" placeholder="银行API地址" />
                    </el-form-item>
                  </el-col>
                </el-row>
              </template>

              <!-- 支付宝配置 -->
              <template v-if="paymentConfig.provider === 'alipay'">
                <el-divider content-position="left">支付宝配置</el-divider>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="应用ID">
                      <el-input v-model="paymentConfig.merchantId" placeholder="支付宝应用AppID" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="签名方式">
                      <el-select v-model="paymentConfig.signType" style="width: 100%;">
                        <el-option label="RSA2" value="RSA2" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="24">
                    <el-form-item label="应用私钥">
                      <el-input v-model="paymentConfig.merchantKey" type="textarea" :rows="3" placeholder="应用私钥内容" />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="24">
                    <el-form-item label="支付宝公钥">
                      <el-input v-model="paymentConfig.merchantCert" type="textarea" :rows="3" placeholder="支付宝公钥" />
                    </el-form-item>
                  </el-col>
                </el-row>
              </template>

              <!-- 通用配置（非手动模式） -->
              <template v-if="paymentConfig.provider !== 'manual'">
                <el-divider content-position="left">通用配置</el-divider>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="回调地址">
                      <el-input v-model="paymentConfig.notifyUrl" placeholder="支付结果回调地址" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="IP白名单">
                      <el-input v-model="paymentConfig.ipWhitelist" placeholder="服务器IP，多个用逗号分隔" />
                    </el-form-item>
                  </el-col>
                </el-row>
              </template>

              <el-divider content-position="left">
                <el-icon><Setting /></el-icon> 支付限额设置
              </el-divider>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="单笔限额">
                    <el-input-number v-model="paymentConfig.singleLimit" :min="0" :step="1000" style="width: 100%;" />
                    <div style="font-size: 12px; color: #909399;">单位：元</div>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="单日限额">
                    <el-input-number v-model="paymentConfig.dailyLimit" :min="0" :step="10000" style="width: 100%;" />
                    <div style="font-size: 12px; color: #909399;">单位：元</div>
                  </el-form-item>
                </el-col>
              </el-row>
              <div style="margin-top: 20px; text-align: right;">
                <el-button type="primary" @click="savePaymentConfig" :loading="saving.payment">
                  <el-icon><Check /></el-icon> 保存支付配置
                </el-button>
              </div>
            </el-form>
          </div>
        </el-tab-pane>

        <!-- 任务配置 -->
        <el-tab-pane label="任务配置" name="task">
          <div class="task-config">
            <el-alert
              title="任务类型和分账规则配置"
              type="info"
              :closable="false"
              style="margin-bottom: 20px"
            >
              在此管理任务类型、分账比例等配置，保存后立即生效。
              <el-button type="primary" size="small" @click="initTaskConfig" style="margin-left: 10px">
                初始化默认配置
              </el-button>
            </el-alert>

            <el-tabs v-model="taskSubTab">
              <el-tab-pane label="任务类型" name="types">
                <el-table :data="taskTypes" border style="width: 100%">
                  <el-table-column prop="code" label="代码" width="120"></el-table-column>
                  <el-table-column prop="name" label="名称" width="120"></el-table-column>
                  <el-table-column prop="description" label="描述"></el-table-column>
                  <el-table-column prop="taskSource" label="来源" width="80">
                    <template #default="scope">
                      <el-tag v-if="scope.row.taskSource === 'merchant'">商家</el-tag>
                      <el-tag v-else type="success">平台</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="enabled" label="启用" width="60">
                    <template #default="scope">
                      <el-switch v-model="scope.row.enabled" @change="updateTaskType(scope.row)"></el-switch>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="100">
                    <template #default="scope">
                      <el-button type="text" @click="editTaskType(scope.row)">编辑</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-tab-pane>

              <el-tab-pane label="分账规则" name="distributions">
                <el-select v-model="selectedTaskType" placeholder="选择任务类型" @change="loadDistributions" style="margin-bottom: 15px">
                  <el-option v-for="t in taskTypes" :key="t.code" :label="t.name" :value="t.code"></el-option>
                </el-select>
                <el-table :data="distributions" border style="width: 100%">
                  <el-table-column prop="role" label="角色" width="120">
                    <template #default="scope">
                      <el-tag v-if="scope.row.role === 'debtor'">债务人</el-tag>
                      <el-tag v-else-if="scope.row.role === 'creditor'">债权人</el-tag>
                      <el-tag v-else type="warning">亲友团</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="cashRatio" label="现金分%" width="100">
                    <template #default="scope">
                      <el-input-number v-model="scope.row.cashRatio" :min="0" :max="100" size="mini" @change="updateDistribution(scope.row)"></el-input-number>
                    </template>
                  </el-table-column>
                  <el-table-column prop="debtResolveRatio" label="解债分%" width="100">
                    <template #default="scope">
                      <el-input-number v-model="scope.row.debtResolveRatio" :min="0" :max="100" size="mini" @change="updateDistribution(scope.row)"></el-input-number>
                    </template>
                  </el-table-column>
                  <el-table-column prop="helperRatio" label="帮扶分%" width="100">
                    <template #default="scope">
                      <el-input-number v-model="scope.row.helperRatio" :min="0" :max="100" size="mini" @change="updateDistribution(scope.row)"></el-input-number>
                    </template>
                  </el-table-column>
                  <el-table-column prop="enabled" label="启用" width="60">
                    <template #default="scope">
                      <el-switch v-model="scope.row.enabled" @change="updateDistribution(scope.row)"></el-switch>
                    </template>
                  </el-table-column>
                </el-table>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-tab-pane>


      </el-tabs>
    </el-card>


    <!-- 任务类型编辑弹窗 -->
    <el-dialog 
      v-model="taskTypeDialogVisible" 
      title="编辑任务类型"
      width="600px"
    >
      <el-form :model="taskTypeForm" :rules="taskTypeRules" label-width="120px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="taskTypeForm.name" placeholder="请输入名称" />
        </el-form-item>
        <el-form-item label="描述">
          <el-input v-model="taskTypeForm.description" type="textarea" :rows="2" placeholder="请输入描述" />
        </el-form-item>
        <el-form-item label="图标">
          <el-input v-model="taskTypeForm.icon" placeholder="图标名称（选填）" />
        </el-form-item>
        <el-form-item label="任务来源">
          <el-select v-model="taskTypeForm.taskSource" style="width: 100%;">
            <el-option label="平台" value="platform" />
            <el-option label="商家" value="merchant" />
          </el-select>
        </el-form-item>
        <el-form-item label="是否公开">
          <el-switch v-model="taskTypeForm.isPublic" active-text="公开" inactive-text="私有" />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="taskTypeForm.sortOrder" :min="0" :max="100" />
        </el-form-item>
        <el-divider content-position="left">佣金比例设置</el-divider>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="债权人%">
              <el-input-number v-model="taskTypeForm.creditorCommission" :min="0" :max="100" style="width: 100%;" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="债务人%">
              <el-input-number v-model="taskTypeForm.debtorCommission" :min="0" :max="100" style="width: 100%;" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="亲友团%">
              <el-input-number v-model="taskTypeForm.friendCommission" :min="0" :max="100" style="width: 100%;" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <el-button @click="taskTypeDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveTaskType">保存</el-button>
      </template>
    </el-dialog>
    <!-- 分类编辑弹窗 -->
    <el-dialog 
      v-model="categoryDialogVisible" 
      :title="categoryForm.id ? '编辑分类' : '添加分类'"
      width="700px"
    >
      <el-form ref="categoryFormRef" :model="categoryForm" :rules="categoryRules" label-width="100px">
        <el-form-item label="分类名称" prop="name">
          <el-input v-model="categoryForm.name" placeholder="请输入分类名称" maxlength="100" />
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input v-model="categoryForm.description" type="textarea" :rows="2" placeholder="请输入分类描述（选填）" />
        </el-form-item>
        <el-form-item label="默认抽成" prop="commissionRate">
          <el-input v-model="categoryForm.commissionRate" type="number" :min="0" :max="100" step="0.1">
            <template #append>%</template>
          </el-input>
          <div style="font-size: 12px; color: #909399; margin-top: 4px;">
            该分类下商户的默认抽成比例，可单独覆盖
          </div>
        </el-form-item>
                <el-form-item label="状态" prop="isActive">
          <el-switch v-model="categoryForm.isActive" active-text="启用" inactive-text="禁用" />
        </el-form-item>
        <el-form-item label="细分领域">
          <div style="width: 100%;">
            <el-button type="primary" size="small" @click="handleAddSubType" style="margin-bottom: 10px;">
              <el-icon><Plus /></el-icon> 添加细分领域
            </el-button>
            <el-table :data="categoryForm.subTypes" size="small" border v-if="categoryForm.subTypes.length > 0" style="margin-top: 10px;">
              <el-table-column prop="value" label="标识" width="120">
                <template #default="{ row }">
                  <el-input v-model="row.value" placeholder="如: hotpot" size="small" />
                </template>
              </el-table-column>
              <el-table-column prop="label" label="名称" width="150">
                <template #default="{ row }">
                  <el-input v-model="row.label" placeholder="如: 火锅/烧烤" size="small" />
                </template>
              </el-table-column>
              <el-table-column prop="rate" label="抽成比例" width="120">
                <template #default="{ row }">
                  <el-input-number v-model="row.rate" :min="0" :max="1" :step="0.01" :precision="3" size="small" style="width: 100%;" />
                </template>
              </el-table-column>
              <el-table-column label="操作" width="80">
                <template #default="{ $index }">
                  <el-button type="danger" size="small" @click="handleRemoveSubType($index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="font-size: 12px; color: #909399; margin-top: 8px;">
              细分领域用于同一分类下不同业务类型的差异化抽成，如餐饮分类下的火锅(6%)、奶茶(9%)等
            </div>
          </div>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="categoryDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSaveCategory">保存</el-button>
      </template>
    </el-dialog>

  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted, watch } from 'vue'
import request from '@/api/index.js'
import { ElMessage, ElMessageBox } from 'element-plus'
import { Refresh, Check, Money, Shop, List, CreditCard, Iphone, ChatDotRound, Wallet, Document, Setting, User, Avatar } from '@element-plus/icons-vue'
import settingsApi from '@/api/settings'
import { getCategories, createCategory, updateCategory, deleteCategory, toggleCategoryStatus } from '@/api/modules/merchant-category.js'
import { Plus } from '@element-plus/icons-vue'

const activeTab = ref('wechat')

// 任务配置相关
const taskSubTab = ref('types')
const taskTypes = ref([])
const distributions = ref([])
const selectedTaskType = ref('')


// 任务类型编辑弹窗
const taskTypeDialogVisible = ref(false)
const taskTypeForm = reactive({
  id: null,
  name: '',
  description: '',
  icon: '',
  taskSource: 'platform',
  isPublic: true,
  sortOrder: 0,
  creditorCommission: 0,
  debtorCommission: 0,
  friendCommission: 0
})
const taskTypeRules = {
  name: [{ required: true, message: '请输入名称', trigger: 'blur' }]
}
const loadTaskTypes = async () => {
  try {
    const res = await request.get('/admin/task-config/types')
    if (res.code === 200) {
      taskTypes.value = res.data
    }
  } catch (e) {
    console.error('加载任务类型失败', e)
  }
}

const loadDistributions = async () => {
  if (!selectedTaskType.value) return
  try {
    const res = await request.get('/admin/task-config/distributions/' + selectedTaskType.value)
    if (res.code === 200) {
      distributions.value = res.data
    }
  } catch (e) {
    console.error('加载分账规则失败', e)
  }
}

const updateTaskType = async (row) => {
  try {
    await request.put('/admin/task-config/types/' + row.id, row)
    ElMessage.success('更新成功')
  } catch (e) {
    ElMessage.error('更新失败')
    loadTaskTypes()
  }
}

const editTaskType = (row) => {
  // 填充表单数据
  taskTypeForm.id = row.id
  taskTypeForm.name = row.name || ''
  taskTypeForm.description = row.description || ''
  taskTypeForm.icon = row.icon || ''
  taskTypeForm.taskSource = row.taskSource || 'platform'
  taskTypeForm.isPublic = row.isPublic !== false
  taskTypeForm.sortOrder = row.sortOrder || 0
  taskTypeForm.creditorCommission = row.creditorCommission || 0
  taskTypeForm.debtorCommission = row.debtorCommission || 0
  taskTypeForm.friendCommission = row.friendCommission || 0
  taskTypeDialogVisible.value = true
}

const saveTaskType = async () => {
  if (!taskTypeForm.name) {
    ElMessage.warning('请输入名称')
    return
  }
  try {
    await request.put('/admin/task-config/types/' + taskTypeForm.id, taskTypeForm)
    ElMessage.success('保存成功')
    taskTypeDialogVisible.value = false
    loadTaskTypes()
  } catch (e) {
    ElMessage.error('保存失败')
  }
}

const updateDistribution = async (row) => {
  try {
    await request.put('/admin/task-config/distributions/' + row.id, row)
  } catch (e) {
    ElMessage.error('更新失败')
    loadDistributions()
  }
}

const initTaskConfig = async () => {
  try {
    await ElMessageBox.confirm('确定要初始化默认任务配置吗？', '提示', { type: 'warning' })
    await request.post('/admin/task-config/init')
    ElMessage.success('初始化成功')
    loadTaskTypes()
  } catch (e) {
    if (e !== 'cancel') {
      ElMessage.error('初始化失败')
    }
  }
}

watch(activeTab, (newVal) => {
  if (newVal === 'task') {
    loadTaskTypes()
  }
})

const loadTaskConfigOnMounted = () => {
  if (activeTab.value === 'task') {
    loadTaskTypes()
  }
}

// 商户分类相关
const categoryList = ref([])
const categoryLoading = ref(false)
const categoryDialogVisible = ref(false)
const categoryFormRef = ref()
const categoryForm = reactive({
  id: null,
  name: '',
  description: '',
  commissionRate: 5,
  subTypes: [], // 细分领域列表
  isActive: true
})
const categoryRules = {
  name: [{ required: true, message: '请输入分类名称', trigger: 'blur' }],
  commissionRate: [{ required: true, message: '请输入抽成比例', trigger: 'blur' }]
}
const loading = reactive({ wechat: false, commission: false, map: false, sms: false, esign: false, email: false, agreement: false, payment: false })
const saving = reactive({ wechat: false, commission: false, map: false, sms: false, esign: false, email: false, agreement: false, payment: false })

// 微信配置
const wechatConfig = reactive({
  miniProgram: { enabled: false, appId: '', appSecret: '', originalId: '', qrCodeUrl: '' },
  officialAccount: { enabled: false, appId: '', appSecret: '', token: '', encodingAESKey: '', originalId: '' },
  pay: { enabled: false, mchId: '', apiKey: '', apiV3Key: '', serialNo: '', privateKey: '', notifyUrl: '', refundNotifyUrl: '' }
})

// 抽成规则配置
const commissionConfig = reactive({
  // 消费返佣基础设置
  platformProfitRate: 0.30,
  userShareRate: 0.70,
  debtResolutionRate: 0.50,
  helperCreditRate: 0.166,
  // V4.0 消费返佣配置
  creditorConsumption: {
    debtResolutionRate: 0.50,    // 债权人消费获得50%解债分
    platformRate: 0.50           // 50%平台利润
  },
  friendConsumption: {
    debtResolutionRate: 0.417,   // 亲友团消费41.7%解债分（转认领人）
    helperCreditRate: 0.166,     // 16.6%帮扶分
    platformRate: 0.417          // 41.7%平台利润
  },
  // 行业抽成设置
  industry: { catering: { hotpot: 0.06, restaurant: 0.055, fastfood: 0.035, drink: 0.09 }, retail: { convenience: 0.025 }, service: { beauty: 0.055, medical: 0.09 }, other: { default: 0.05 } },
  // 任务分配规则
  task: { lifeService: { cashRate: 0.60, debtRate: 0.25, platformRate: 0.15 }, employment: { cashRate: 0.70, debtRate: 0.15, platformRate: 0.15 }, entrepreneurship: { cashRate: 0.50, debtRate: 0.30, platformRate: 0.20 } },
  // 现金分卡手续费
  cashCard: { onlineFeeRate: 0, offlineFeeRate: 0.02 },
  // V4.0 积分手续费设置
  creditFees: {
    withdrawFeeRate: 0.10,       // 提现手续费 10%
    tradeFeeRate: 0.05,          // 交易手续费 5%
    transferFeeRate: 0.05        // 转账手续费 5%
  },
  // V4.0 积分功能开关
  creditSwitches: {
    tradeEnabled: true,          // 交易功能开关
    transferEnabled: true,       // 转账功能开关
    helperExchangeEnabled: true, // 帮扶分兑换开关
    withdrawEnabled: true,       // 提现功能开关
    minWithdrawAmount: 1000      // 最低提现金额 1000元
  }
})

const industryTableData = computed(() => {
  const data = []
  const industryNames = { catering: '餐饮业', retail: '零售业', service: '服务业', other: '其他' }
  const subNames = { hotpot: '火锅/烧烤', restaurant: '正餐餐饮', fastfood: '快餐/小吃', drink: '饮品/奶茶', convenience: '超市/便利店', beauty: '美容美发', medical: '医美/口腔', default: '默认' }
  for (const [type, subs] of Object.entries(commissionConfig.industry)) {
    for (const [sub, rate] of Object.entries(subs)) {
      data.push({ type, sub, name: industryNames[type], subName: subNames[sub], rate })
    }
  }
  return data
})

const taskTableData = computed(() => {
  const names = { lifeService: '生活服务类', employment: '就业类', entrepreneurship: '创业类' }
  return Object.entries(commissionConfig.task).map(([key, value]) => ({ key, name: names[key], ...value }))
})

const mapConfig = reactive({ enabled: true, provider: 'tencent', tencentKey: '', baiduAk: '', amapKey: '', amapSecret: '' })
const smsConfig = reactive({ enabled: false, provider: 'tencent', tencentSecretId: '', tencentSecretKey: '', tencentAppId: '', tencentSignName: '', tencentTemplateId: '', tencentInviteTemplateId: '' })
const esignConfig = reactive({ enabled: false, provider: 'self', tencentSecretId: '', tencentSecretKey: '', tencentAppId: '' })
const emailConfig = reactive({ enabled: false, host: 'smtp.qq.com', port: 465, secure: true, user: '', password: '', fromName: '富福德正' })

// 协议配置
const agreementConfig = reactive({
  userAgreement: '',
  privacyPolicy: ''
})
// ========== 支付配置 V4.0 ==========
const paymentConfig = reactive({
  enabled: false,
  provider: 'manual',
  merchantId: '',
  merchantKey: '',
  merchantCert: '',
  apiV3Key: '',
  bankName: '',
  bankAccount: '',
  bankAccountName: '',
  apiUrl: '',
  notifyUrl: 'https://ffdzheng.com/api/payment/callback',
  signType: 'MD5',
  ipWhitelist: '',
  dailyLimit: 50000,
  singleLimit: 5000
})

const onProviderChange = (val) => {
  if (val === 'manual') {
    paymentConfig.enabled = false
  }
}

const fetchPaymentConfig = async () => {
  loading.payment = true
  try {
    const res = await settingsApi.getPaymentConfig()
    if (res.code === 200 && res.data) {
      Object.assign(paymentConfig, res.data)
    }
  } catch (e) {
    console.error('获取支付配置失败', e)
  } finally {
    loading.payment = false
  }
}

const savePaymentConfig = async () => {
  saving.payment = true
  try {
    await settingsApi.savePaymentConfig(paymentConfig)
    ElMessage.success('支付配置保存成功')
  } catch (e) {
    ElMessage.error('保存失败')
  } finally {
    saving.payment = false
  }
}



// ========== 微信配置 ==========
const fetchWechatConfig = async () => {
  loading.wechat = true
  try {
    const res = await settingsApi.getWechatConfig()
    if (res.code === 200 && res.data) {
      Object.assign(wechatConfig.miniProgram, res.data.miniProgram || {})
      Object.assign(wechatConfig.officialAccount, res.data.officialAccount || {})
      Object.assign(wechatConfig.pay, res.data.pay || {})
    }
  } catch (e) { console.error('获取微信配置失败:', e) }
  finally { loading.wechat = false }
}

const saveWechatConfig = async () => {
  saving.wechat = true
  try {
    const res = await settingsApi.saveWechatConfig(wechatConfig)
    if (res.code === 200) ElMessage.success('微信配置保存成功')
    else ElMessage.error(res.message || '保存失败')
  } catch (e) { ElMessage.error('保存失败') }
  finally { saving.wechat = false }
}

// ========== 抽成规则 ==========
const fetchCommissionConfig = async () => {
  loading.commission = true
  try {
    const res = await settingsApi.getCommissionConfig()
    if (res.code === 200 && res.data) Object.assign(commissionConfig, res.data)
  } catch (e) { console.error('获取抽成配置失败:', e) }
  finally { loading.commission = false }
}

const saveCommissionConfig = async () => {
  saving.commission = true
  try {
    const res = await settingsApi.saveCommissionConfig(commissionConfig)
    if (res.code === 200) ElMessage.success('抽成规则配置保存成功')
    else ElMessage.error(res.message || '保存失败')
  } catch (e) { ElMessage.error('保存失败') }
  finally { saving.commission = false }
}

// ========== 其他配置 ==========
const fetchMapConfig = async () => {
  loading.map = true
  try {
    const res = await settingsApi.getMapConfig()
    if (res.code === 200 && res.data) {
      mapConfig.enabled = res.data.enabled !== false
      mapConfig.provider = res.data.provider || 'tencent'
      mapConfig.tencentKey = res.data.tencentKey || ''
      mapConfig.baiduAk = res.data.baiduAk || ''
      mapConfig.amapKey = res.data.amapKey || ''
    }
  } catch (e) {}
  finally { loading.map = false }
}

const saveMapConfig = async () => {
  saving.map = true
  try {
    const res = await settingsApi.saveMapConfig(mapConfig)
    if (res.code === 200) ElMessage.success('地图配置保存成功')
    else ElMessage.error(res.message || '保存失败')
  } catch (e) { ElMessage.error('保存失败') }
  finally { saving.map = false }
}

const fetchSmsConfig = async () => {
  loading.sms = true
  try {
    const res = await settingsApi.getSmsConfig()
    if (res.code === 200 && res.data) {
      smsConfig.enabled = res.data['sms.enabled'] === true || res.data['sms.enabled'] === 'true'
      smsConfig.provider = res.data['sms.provider'] || 'tencent'
      smsConfig.tencentSecretId = res.data['sms.tencent.secretId'] || ''
      smsConfig.tencentSecretKey = res.data['sms.tencent.secretKey'] || ''
      smsConfig.tencentAppId = res.data['sms.tencent.appId'] || ''
      smsConfig.tencentSignName = res.data['sms.tencent.signName'] || ''
      smsConfig.tencentTemplateId = res.data['sms.tencent.templateId'] || ''
      smsConfig.tencentInviteTemplateId = res.data['sms.tencent.inviteTemplateId'] || ''
    }
  } catch (e) {}
  finally { loading.sms = false }
}

const saveSmsConfig = async () => {
  saving.sms = true
  try {
    const res = await settingsApi.saveSmsConfig(smsConfig)
    if (res.code === 200) ElMessage.success('短信配置保存成功')
    else ElMessage.error(res.message || '保存失败')
  } catch (e) { ElMessage.error('保存失败') }
  finally { saving.sms = false }
}

const fetchEsignConfig = async () => {
  loading.esign = true
  try {
    const res = await settingsApi.getEsignConfig()
    if (res.code === 200 && res.data) {
      esignConfig.enabled = res.data['esign.enabled'] === true || res.data['esign.enabled'] === 'true'
      esignConfig.provider = res.data['esign.provider'] || 'self'
      esignConfig.tencentSecretId = res.data['esign.tencent.secretId'] || ''
      esignConfig.tencentSecretKey = res.data['esign.tencent.secretKey'] || ''
      esignConfig.tencentAppId = res.data['esign.tencent.appId'] || ''
    }
  } catch (e) {}
  finally { loading.esign = false }
}

const saveEsignConfig = async () => {
  saving.esign = true
  try {
    const res = await settingsApi.saveEsignConfig(esignConfig)
    if (res.code === 200) ElMessage.success('电子签配置保存成功')
    else ElMessage.error(res.message || '保存失败')
  } catch (e) { ElMessage.error('保存失败') }
  finally { saving.esign = false }
}

const fetchEmailConfig = async () => {
  loading.email = true
  try {
    const res = await settingsApi.getEmailConfig()
    if (res.code === 200 && res.data) {
      emailConfig.enabled = res.data['email.enabled'] === true || res.data['email.enabled'] === 'true'
      emailConfig.host = res.data['email.host'] || 'smtp.qq.com'
      emailConfig.port = parseInt(res.data['email.port']) || 465
      emailConfig.user = res.data['email.user'] || ''
      emailConfig.password = res.data['email.password'] || ''
      emailConfig.fromName = res.data['email.fromName'] || '富福德正'
    }
  } catch (e) {}
  finally { loading.email = false }
}

const saveEmailConfig = async () => {
  saving.email = true
  try {
    const res = await settingsApi.saveEmailConfig(emailConfig)
    if (res.code === 200) ElMessage.success('邮件配置保存成功')
    else ElMessage.error(res.message || '保存失败')
  } catch (e) { ElMessage.error('保存失败') }
  finally { saving.email = false }
}

// 获取协议配置
const fetchAgreementConfig = async () => {
  loading.agreement = true
  try {
    const [userRes, privacyRes] = await Promise.all([
      fetch('/api/settings/agreement/user').then(r => r.json()),
      fetch('/api/settings/agreement/privacy').then(r => r.json())
    ])
    if (userRes.code === 200) agreementConfig.userAgreement = userRes.data.content
    if (privacyRes.code === 200) agreementConfig.privacyPolicy = privacyRes.data.content
  } catch (e) {}
  finally { loading.agreement = false }
}

// 保存协议
const saveAgreement = async (type) => {
  saving.agreement = true
  try {
    const content = type === 'user' ? agreementConfig.userAgreement : agreementConfig.privacyPolicy
    const key = type === 'user' ? 'user_agreement' : 'privacy_policy'
    const res = await settingsApi.saveSetting(key, content, 'basic', type === 'user' ? '用户注册协议' : '隐私政策')
    if (res.code === 200) ElMessage.success('保存成功')
    else ElMessage.error(res.message || '保存失败')
  } catch (e) { ElMessage.error('保存失败') }
  finally { saving.agreement = false }
}

const initDefaultSettings = async () => {
  try {
    const res = await settingsApi.initDefaultSettings()
    if (res.code === 200) {
      ElMessage.success('默认设置初始化成功')
      fetchCommissionConfig()
      fetchWechatConfig()
    }
  } catch (e) { ElMessage.error('初始化失败') }
}



// 商户分类相关方法
const fetchCategories = async () => {
  try {
    categoryLoading.value = true
    const response = await getCategories(true)
    categoryList.value = response || []
  } catch (error) {
    console.error('获取分类失败', error)
  } finally {
    categoryLoading.value = false
  }
}

const handleAddCategory = () => {
  categoryForm.id = null
  categoryForm.name = ''
  categoryForm.description = ''
  categoryForm.commissionRate = 5
  categoryForm.isActive = true
  categoryDialogVisible.value = true
}



// 添加细分领域
const handleAddSubType = () => {
  categoryForm.subTypes.push({
    value: '',
    label: '',
    rate: categoryForm.commissionRate / 100 // 默认使用分类抽成
  })
}

// 删除细分领域
const handleRemoveSubType = (index) => {
  categoryForm.subTypes.splice(index, 1)
}

const handleEditCategory = (row) => {
  categoryForm.id = row.id
  categoryForm.name = row.name
  categoryForm.description = row.description || ''
  categoryForm.commissionRate = row.commissionRate * 100
  categoryForm.subTypes = row.subTypes ? [...row.subTypes] : []
  categoryForm.isActive = Boolean(row.isActive)
  categoryDialogVisible.value = true
}

const handleSaveCategory = async () => {
  try {
    const data = {
      name: categoryForm.name,
      description: categoryForm.description,
      commissionRate: categoryForm.commissionRate / 100,
      subTypes: categoryForm.subTypes.filter(s => s.value && s.label), // 过滤无效项
      isActive: categoryForm.isActive
    }
    
    let res
    if (categoryForm.id) {
      res = await updateCategory(categoryForm.id, data)
    } else {
      res = await createCategory(data)
    }
    
    if (res.id || res.message) {
      ElMessage.success(categoryForm.id ? '分类已更新' : '分类已创建')
      categoryDialogVisible.value = false
      fetchCategories()
    }
  } catch (error) {
    ElMessage.error(error.message || '操作失败')
  }
}

const handleToggleCategory = async (row) => {
  try {
    await toggleCategoryStatus(row.id)
    ElMessage.success(row.isActive ? '分类已禁用' : '分类已启用')
    fetchCategories()
  } catch (error) {
    ElMessage.error('操作失败')
  }
}

const handleDeleteCategory = async (row) => {
  try {
    await ElMessageBox.confirm('确定要删除分类"' + row.name + '"吗？', '删除确认', { type: 'warning' })
    await deleteCategory(row.id)
    ElMessage.success('分类已删除')
    fetchCategories()
  } catch (error) {
    if (error !== 'cancel') ElMessage.error('删除失败')
  }
}

const formatDateTime = (dateString) => {
  if (!dateString) return ''
  const date = new Date(dateString)
  return date.toLocaleString('zh-CN')
}

onMounted(() => {
  fetchWechatConfig()
  fetchCommissionConfig()
  fetchAgreementConfig()
  fetchMapConfig()
  fetchSmsConfig()
  fetchEsignConfig()
  fetchEmailConfig()
  fetchCategories()
  fetchPaymentConfig()
  loadTaskTypes()
})
</script>

<style scoped>
.system-settings { padding: 20px; }
.header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; }
.header h2 { margin: 0; }
.unit { margin-left: 8px; color: #606266; font-size: 14px; }
</style>
